/* eslint-disable */
import { useState, useEffect } from 'react';
import { Modal, ModalBody, Row, Col, Container, Form } from 'reactstrap';
import { orderBy } from 'lodash';
import { useTranslation } from 'react-i18next';

import useApi from 'vl-common/src/hooks/useApi';
import Datestamp from '../Datestamp';
import { LoadingButton } from 'vl-common/src/components/LoadingButton';

const ViewNotesModal = ({ data, close, show, getNotesParams }) => {
  const { t } = useTranslation('common');
  const { Api } = useApi();
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    if (show) {
      if (data) {
        Api.notes
          .getNotes({
            ...getNotesParams,
            page: 1,
            rows: 999
          })
          .then((res) => {
            const {
              data: { patient_notes }
            } = res;

            if (patient_notes?.length > 0) {
              setNotes(orderBy(patient_notes, ['date_added'], ['desc']));
            }
          })
          .catch((e) => {
            console.log(e);
            setNotes([]);
          });
      }
    }
  }, [show]);

  return (
    <Modal
      centered
      className="vl-add-modal"
      size={'xl'}
      isOpen={show}
      toggle={close}
      keyboard={false}
      backdrop={'static'}
      data-testid="view-notes-modal"
    >
      <ModalBody className="p-5 vl-addNote">
        <Container fluid={true}>
          <Row>
            <Col xs="12" className="text-center">
              <span className="vl-modal-title">
                <span className="vl-product-pink">{t('Notes')}</span>
              </span>
            </Col>
            <Col xs="12">
              <div className="text-center subtext key">{t('Patient notes')}</div>
            </Col>
            <br />
            <Col xs="12">
              <Form className="mt-4">
                <Row>
                  <Col xs="12">
                    <div className="scroll-able">
                      {notes.map((item, i) => {
                        return (
                          <div className="note" key={'note' + i}>
                            <div className="note-item vl-flex-row-start">
                              <div className="key">{t('Added by:')}</div>
                              <div className="value">{item.added_by}</div>
                            </div>
                            <div className="note-item vl-flex-row-start">
                              <div className="key">Date &amp; time Added:</div>
                              <div className="value">
                                <Datestamp date={item.date_added} format="Date @ Time - 03/01/2022 @ 08:57" />
                              </div>
                            </div>
                            <div className="note-item">
                              <span className="key">{t('Notes:')}</span>
                              <span className="value">{item.note_text}</span>
                            </div>
                            <div className="divider" />
                          </div>
                        );
                      })}
                    </div>
                  </Col>
                  <Col xs="12" className="mt-3 text-right">
                    <LoadingButton className="vl-button vl-font-regular min-width" onClick={close}>
                      {t('Ok')}
                    </LoadingButton>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export { ViewNotesModal };
